export default "__VITE_ASSET__CR_lio_7__"